import React from 'react';

import ReportInfoModule from '../modules/ReportInfoModule.js';
import ReportNarrativeModule from '../modules/ReportNarrativeModule.js';
import ReportSuggestionsModule from '../modules/ReportSuggestionsModule.js';
import ReportFeedbackModule from '../modules/ReportFeedbackModule.js';
import PilotFeedbackModule from '../modules/PilotFeedbackModule.js';
import SchematronModule from '../modules/SchematronModule.js';
import './Box.css';

const ReportFeedbackBox = ({user, reportId, isSmallScreen}) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            {/* <h1 className='box-title'> Report Feedback </h1> */}
            <h4></h4>
            <ReportInfoModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
            {/* {user.subscriptions.includes('CADMUS_AUDITOR') && <PilotFeedbackModule user={user} reportId={reportId} isSmallScreen={isSmallScreen} />} */}
            {/* {!user.subscriptions.includes('CADMUS_AUDITOR') && <ReportNarrativeModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>} */}
            {/* {user.subscriptions.includes('CADMUS_AUDITOR') && <ReportSuggestionsModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>} */}
            <ReportFeedbackModule user={user} reportId={reportId} isSmallScreen={isSmallScreen} />
            {/* <SchematronModule user={user} reportId={reportId} isSmallScreen={isSmallScreen} /> */}
        </div>
    );
}

export default ReportFeedbackBox;